<template>
    <div>
        <template v-if="width < 2054 && width > 1699">
            <vs-row justify="flex-end">
                <vs-col :key="index" v-for="(col, index) in 3" w="2"><br /></vs-col>
            </vs-row>
        </template>
        <vx-card title="포인트적립내역">
            <vs-row class="mb-3" vs-type="flex" vs-align="center">
                <vs-input class="w-2/5" icon="search" placeholder="환자이름 or 전화번호" v-model="search" @keyup.enter="history()" />
                <vs-button class="ml-1" @click="history('init')">초기화</vs-button>
                <vs-button class="ml-1" @click="triggerFileInput">업로드</vs-button>
                <input type="file" ref="excelFile" @change="handleFileUpload" style="display: none" />
            </vs-row>
            <div class="tb_box">
                <table id="list" style="width:100%;min-width:1400px;" class="border-collapse calendar">
                    <colgroup>
                        <col width="10%" />
                        <col width="15%" />
                        <col width="10%" />
                        <col width="10%" />
                        <col width="10%" />
                        <col width="*" />
                        <col width="10%" />
                        <col width="10%" />
                        <col width="10%" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">환자이름</th>
                            <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">전화번호</th>
                            <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">포인트 증감</th>
                            <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">포인트 잔액</th>
                            <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">알림톡</th>
                            <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">세부내역</th>
                            <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">산소일정</th>
                            <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">등록일시</th>
                            <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">등록자</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in list" :key="index">
                            <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.PATIENT_NAME }}</td>
                            <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.PATIENT_PHONE }}</td>
                            <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.POINT_VALUE }}</td>
                            <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.POINT_SUM }}</td>
                            <td class="p-2 border border-solid d-theme-border-grey-light text-center">
                                <template v-if="item.SEND_YN === 'Y'">
                                    <vs-icon icon="check_circle" color="success" size="20px"></vs-icon>
                                </template>
                                <template v-else>
                                    <vs-icon 
                                        icon="error" 
                                        color="danger" 
                                        size="20px" 
                                        @click="showRetryPopup(item)"
                                        style="cursor: pointer"
                                    ></vs-icon>
                                </template>
                            </td>
                            <td class="p-2 border border-solid d-theme-border-grey-light text-left">{{ item.POINT_DETAIL }}</td>
                            <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.SCHEDULE_DATE }}</td>
                            <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ $moment(item.REG_DATE).format('YYYY-MM-DD HH:mm:ss') }}</td>
                            <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.REG_NAME }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <br />
            <vs-pagination :total="total_page" v-model="page" @input="history('p')" :max="7"></vs-pagination>
        </vx-card>
    </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
import moment from 'moment';
import * as XLSX from 'xlsx';
import store from '@/store/store';
export default {
    data() {
        return {
            page: 1,
            total_page: 0,
            list: [],
            width: window.innerWidth,
            search: '',
        };
    },
    methods: {
        handleResize(event) {
            this.width = window.innerWidth;
        },
        init(type) {
            this.history(type);
        },
        async history(type) {
            if (type != 'p') {
                this.page = 1;
            }
            if (type == 'init') {
                this.search = '';
            }
            
            const params = {
                page: this.page,
                search: this.search,
            };
            const { data } = await axiosClass.get('/api/management/oxygenPointHistory', params, true);
            this.list = data.list;
            this.total_page = data.pageCount;
            setTimeout(() => {
                this.$vs.loading.close('#list > .con-vs-loading');
            }, 100);
        },
        triggerFileInput() {
            this.$refs.excelFile.click();
        },
        async handleFileUpload(event) {
            const file = event.target.files[0];
            if (!file) return;

            // 엑셀 파일 읽기
            const data = await file.arrayBuffer();
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            // 엑셀 데이터를 JSON으로 변환
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            // 데이터 가공: 첫 번째 행(헤더)을 제외하고 각 행을 객체로 변환
            const formattedData = jsonData.slice(1).map(row => {
                return {
                    phone: row[0],    // A열 데이터 - 핸드폰 번호
                    value: row[1],    // B열 데이터 - 정수 값
                };
            }).filter(item => item.phone && item.value); // 빈 값 필터링

            // 데이터를 서버로 전송
            await this.uploadExcel(formattedData);
        },
        async uploadExcel(data) {
            console.log('전송할 데이터:', data);
            console.log('데이터 개수:', data.length);

            try {
                const response = await axiosClass.post('/api/management/uploadExcel', {
                    data : data,
                    regId : store.getters.getUID
                }, true);
                console.log('업로드 응답:', response);

                this.$vs.notify({
                    title: '성공',
                    text: `${data.length}건의 포인트가 적립되었습니다.`,
                    color: 'success'
                });

                this.history(); // 데이터 갱신
            } catch (error) {
                console.error("Excel upload failed:", error);
                this.$vs.notify({
                    title: '실패',
                    text: '엑셀 업로드에 실패했습니다.',
                    color: 'danger'
                });
            }
        },
        showRetryPopup(item) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: '알림톡 재전송',
                text: `${item.PATIENT_NAME}님에게 알림톡을 재전송하시겠습니까?`,
                acceptText: '확인',
                cancelText: '취소',
                accept: () => {
                    this.resendMessage(item);
                }
            });
        },
        async resendMessage(item) {
            try {
                this.$vs.loading();
                
                const response = await axiosClass.post('/api/management/resendOxygenMessage', {
                    pointId: item.POINT_ID,
                    patientName: item.PATIENT_NAME,
                    patientPhone: item.PATIENT_PHONE,
                    pointValue: item.POINT_VALUE,
                    totalValue: item.POINT_SUM,
                    reason: item.POINT_DETAIL
                }, true);
                
                this.$vs.loading.close();
                
                if (response.data.result === 'success') {
                    this.$vs.notify({
                        title: '성공',
                        text: '알림톡이 성공적으로 전송되었습니다.',
                        color: 'success'
                    });
                    this.history(); // 데이터 갱신
                } else {
                    this.$vs.notify({
                        title: '실패',
                        text: '알림톡 전송에 실패했습니다.',
                        color: 'danger'
                    });
                }
                this.init(this.search);
            } catch (error) {
                this.$vs.loading.close();
                this.$vs.notify({
                    title: '오류',
                    text: '알림톡 전송 중 오류가 발생했습니다.',
                    color: 'danger'
                });
                console.error('메시지 전송 실패:', error);
            }
        },
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.init();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
};
</script>

<style></style>
